/* eslint-disable no-nested-ternary */
import React from "react";
import { useSelector } from "react-redux";
import CustomTooltip from "../../Core/Components/CustomTooltip";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";
import { BE_RATE_OPERATION_TYPE } from "../Rates/Energy/constants";
import { RENTAL_STATUS } from "./constant";

export const BatteriesColumn = ({ record }) => {
  const getTotalBatteries = () => {
    if (record.batteries.length === 1) return "1 Battery";
    return `${record.batteries.length} Batteries`;
  };

  const getEnergy = (item) => {
    if (+record.status === RENTAL_STATUS.ONGOING) return item.startEnergy;

    return parseFloat(
      parseFloat(item.startEnergy) - parseFloat(item.endEnergy),
    ).toFixed(1);
  };

  if (!record?.batteries?.length)
    return (
      <p className="font-aileron text-xs font-semibold text-dark-gray">
        No Batteries Connected
      </p>
    );

  return (
    <CustomTooltip
      trigger="click"
      bgColor="#ffffff"
      tooltipTitle={
        <div className="p-2 rounded-md w-[226px]">
          {record?.batteries?.map((item, index) => (
            <div
              key={item.id}
              className={` ${
                index < record.batteries.length - 1
                  ? "pb-2 mb-2 border-b border-light-grey"
                  : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <p className="font-aileron text-xs font-normal text-dark-gray">
                  Registration no.
                </p>

                <p className="font-aileron text-xs font-semibold text-black">
                  {item?.registrationNo}
                </p>
              </div>

              <div className="mt-2 flex items-center justify-between">
                <p className="font-aileron text-xs font-normal text-dark-gray">
                  Type
                </p>

                <p className="font-aileron text-xs font-semibold text-black capitalize">
                  {item?.type || "--"}
                </p>
              </div>

              <div className="mt-2 flex items-center justify-between">
                <p className="font-aileron text-xs font-normal text-dark-gray">
                  Energy
                </p>

                <p className="font-aileron text-xs font-semibold text-black">
                  {getEnergy(item) || "--"} kWh
                </p>
              </div>
            </div>
          ))}
        </div>
      }
    >
      <div className="flex items-center gap-x-1">
        <p className="font-aileron text-xs font-semibold text-dark-gray whitespace-nowrap">
          {getTotalBatteries()}
        </p>

        <ChevronIcon className="w-4 h-4 rotate-90 stroke-dark-gray" />
      </div>
    </CustomTooltip>
  );
};

export const EnergyConsumedColumn = ({ record }) => {
  const getEnergyConsumed = () => {
    let energyConsumed = 0;

    if (!record?.batteries?.length) return "--";

    record?.batteries?.forEach((item) => {
      energyConsumed +=
        parseFloat(item.startEnergy) - parseFloat(item.endEnergy);
    });

    return energyConsumed
      ? `${parseFloat(energyConsumed).toFixed(1)} kWh`
      : "--";
  };

  return (
    <div className="text-xs font-semibold font-aileron text-dark-gray">
      {getEnergyConsumed()}
    </div>
  );
};

export const EnergyRevenueColumn = ({ record }) => {
  const { allRates } = useSelector((state) => state.rates);

  // const original = record.originalBatteries || [];
  // const swapped = record.swapBatteries || [];

  const rentalHubId = record?.hubId || 0;

  const getRevenue = () => {
    let revenue = 0;

    record?.batteries?.forEach((battery) => {
      const { type, startEnergy, endEnergy } = battery;

      // const hubId = original.includes(+id)
      //   ? record?.originalBattHub
      //   : swapped.includes(+id)
      //   ? record?.swappedBattHub
      //   : 0;

      const batteryEnergyRate = allRates.find(
        (r) =>
          +r.hubId === +rentalHubId &&
          r.batteryTypeName === type &&
          +r.operationTypeId === BE_RATE_OPERATION_TYPE.RENTAL,
      );

      let rate = 0;

      if (batteryEnergyRate) {
        rate = parseFloat(batteryEnergyRate.rate);
      }

      revenue += parseFloat(
        (parseFloat(startEnergy) - parseFloat(endEnergy)) * rate,
      );
    });

    return revenue ? `${parseFloat(revenue).toFixed(0)} KSH` : "--";
  };

  if (!record?.batteries?.length) {
    return (
      <div className="text-xs font-semibold font-aileron text-dark-gray">
        --
      </div>
    );
  }

  return (
    <div className="text-xs font-semibold font-aileron text-dark-gray">
      {getRevenue()}
    </div>
  );
};
